import React from 'react'

const TermsOfService = () => {
  return (
    <div>
        
        <h1>GENERIC CONTENT!</h1>
        This Terms of Service Agreement (the “Agreement”) is a binding legal agreement between [Company Name], a company incorporated in [state], and each user who accesses and uses the website located at [URL] (the “Site”).

    By accessing and using the Site, you agree to be bound by this Agreement and to use the Site in accordance with this Agreement. If you do not agree to the terms and conditions of this Agreement, you may not use the Site.
    
    We reserve the right to modify this Agreement at any time. All changes to this Agreement will be posted on the Site and will become effective immediately upon posting. Your continued use of the Site after any changes are posted constitutes your agreement to such changes.
    
    You are solely responsible for all activities that occur under your account, including all purchases made using your account. You must keep your account information secure and not share it with anyone else.
    
    You may not use the Site for any illegal or unauthorized purpose. You must not, in the use of the Site, violate any laws in your jurisdiction (including but not limited to copyright laws).
    
    We reserve the right to terminate your account and access to the Site if we believe you have violated this Agreement.
    </div>
  )
}

export default TermsOfService